import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import app from './modules/app'
import land from './modules/land'
import lowcode from './modules/lowcode'
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    app,
    land,
    lowcode
  },
  // 严格模式
  strict: process.env.NODE_ENV !== 'production',
});
